import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { loaderHandler } from "src/lib/loaderHandler";
import { AdminProductsPage } from "src/pages/AdminProductsPage";
import { coachProductsFeesQueryOptions } from "src/queries/coachProductsFees";
import { platformSettingsQueryOptions } from "src/queries/platformSettings";

export const COACH_PRODUCTS_FEES_DEFAULT_PAGE_SIZE = 20;

const routeSearchSchema = z.object({
  q: z.string().optional(),
  p: z.number().optional(),
  ps: z.number().optional(),
});

export const Route = createFileRoute("/_auth/_admin/admin/products")({
  component: AdminProductsPage,
  validateSearch: routeSearchSchema,
  ssr: true,
  loaderDeps: ({ search }) => {
    return search;
  },
  staticData: {
    getBreadcrumb() {
      return {
        label: "Products",
        href: "/admin/products",
      };
    },
  },
  async loader({ deps, context }) {
    return await loaderHandler(async () => {
      await Promise.all([
        context.queryClient.query({
          ...platformSettingsQueryOptions(),
          staleTime: "static",
        }),
        context.queryClient.query({
          ...coachProductsFeesQueryOptions({
            query: deps.q ?? "",
            pageIndex: deps.p ?? 0,
            pageSize: deps.ps ?? COACH_PRODUCTS_FEES_DEFAULT_PAGE_SIZE,
          }),
          staleTime: "static",
        }),
      ]);

      return { data: {} };
    });
  },
});
